module.exports = __webpack_public_path__ + "assets/checked-icon-9dfbb9.svg";